import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { 
  Layout, Breadcrumb, Form, Input, Table, Divider, List, Avatar,Checkbox,
  Select, Button, Tag, Tabs, DatePicker, Icon, Switch, message
} from 'antd';
import { SearchOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import _ from 'lodash';
import './styles.module.scss';
import {API_HOST}  from '../../configs/env';
import whttp    from '../../libs/whttp';
import axios    from 'axios';
import buildURL from 'axios/lib/helpers/buildURL';
import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton'
import { genFormItemAtrribute } from 'libs/FormHelper'
import AppHelper from 'libs/AppHelper'

const FormItem = Form.Item;
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4, }

export default class HotKeywords extends Component {
  formRef = React.createRef()
  manualFormRef = React.createRef()
  manualTableFormRef = React.createRef()

  state = {
    tableData: {
      "current"  :  0, //目前頁數
      "page_size": 10, //一頁幾筆
      "total"    :  0, //以此query條件，總共幾筆資料
      "rows"     : []
    },
    tableQuery:{
      keyword : null,
      category_ids:[],
    },
    message: '',
    keyword: '',
    formListAddMethod: null
  }
  componentDidMount(){
    AppHelper.updateConfig()
    this.loadData()
  }
  // 拉Table資料
  loadData = (opt = {page: 1, page_size:10}) => {
    const tableQuery = this.formRef.current.getFieldValue();
    //const { tableQuery } = this.state;
    const { page,  page_size} = opt;
    this.setState({ isLoadingData:true } )

    whttp.get(API_HOST + '/api/mgt/v1/hot-keywords', {
      page: page,
      page_size: page_size,
      keyword  : _.get(tableQuery, 'keyword')
    }, (state, res) => {
      this.setState({ isLoadingData:false } )
      const {code=100, reason='發生錯誤', data={} } = res;

      if (state === false) { return this.setState({ message: '發生錯誤' }); }

      if (code !== 200)    { return this.setState({ message: reason }); }

      this.setState({ tableData:data })
      this.fillData(data)
    });
  }

  // 手動新增熱門關鍵字
  submitAddHotKeyword = (item = null) => {
    if(this.state.formListAddMethod != null)
    {
      const formFields = this.manualTableFormRef.current.getFieldValue();
      if(formFields.manual_rows.find(row => row.keyword === item.keyword) != null) {
        return message.error('已存在於手動清單中')
      }
      this.state.formListAddMethod({
        keyword: item.keyword,
        sort: 999
      });
    }
    return
  }

  // 保存資料
  submitManualData = () => {
    const formFields = this.manualTableFormRef.current.getFieldValue();
    const manualSet = this.manualFormRef.current.getFieldValue();
    const { manual_rows } = formFields;
    const { is_manual } = manualSet;

    console.log('is manual', is_manual)

    const payload = manual_rows.map((row, idx) => {
      return {
        id: row.id,
        keyword: row.keyword,
        sort: row.sort
      }
    })

    whttp.post(API_HOST + '/api/mgt/v1/hot-keywords', {
      keywords: payload,
      is_manual
    }, (state, res) => {
      const {code=100, reason='發生錯誤', data={} } = res;

      if (state === false) { return this.setState({ message: '發生錯誤' }); }

      if (code !== 200)    { return this.setState({ message: reason }); }

      message.success('儲存成功')
      this.setState({ tableData:data })
      this.fillData(data)
    });
  }

  fillData = (data = {}) => {
    if (!this.manualTableFormRef.current) return;
    this.manualTableFormRef.current.setFieldsValue(data);
    
    if(!this.manualFormRef.current) return
    this.manualFormRef.current.setFieldsValue(data)
  };

  render() {
    const {tableQuery ={}, tableData={} } = this.state;
    const {app: { options:{fields:optionFields=[]} }} = this.props;
    const permissions = _.get(this.props, 'auth.permissions', {});
    const options = _.get(this, 'props.app.options', {})

    return (
      <Layout>
        <Breadcrumb>
          <Breadcrumb.Item><Link to={`/hotkeywords`}>熱門關鍵字</Link></Breadcrumb.Item>
        </Breadcrumb>
        
        <h2>熱門關鍵字</h2>
        <p></p>

        <div className="flexBox">
          <div className="auto-block col_12">
            <div className="block search">
              <Form 
                ref={this.formRef}>
                <div className='flexBox col_12'>
                  <FormItem {...genFormItemAtrribute('keyword', '關鍵字查詢')}>
                    <Input />
                  </FormItem>
                </div>
                <Form.Item style={{ textAlign: 'right' }}>
                  <Button onClick={(event) => {
                    this.formRef.current.resetFields()
                    this.setState({ tableQuery: {} })
                    this.loadData()
                  }}>取消</Button>
                  
                  <Button 
                    type="primary" 
                    style={{ marginLeft: 8 }} 
                    icon={<SearchOutlined />} 
                    onClick={(event) => this.loadData()}
                  >搜尋</Button>
                </Form.Item>
              </Form>
            </div>
            
            <div className='toolbar'>
              <h3>熱門關鍵字列表(自動)<span></span></h3>
            </div>

            <Table  
              dataSource={tableData.auto_rows} 
              loading={this.state.isLoadingData}
              pagination = {{ 
                current  : _.get(tableData,'current',[]),
                total    : _.get(tableData,'total',0),
                pageSize : _.get(tableData,'page_size',0),
                onChange: (page, page_size) => { this.loadData({page: page, page_size:page_size})},
              }}
              columns={[
                    { dataIndex: 'id'            , title: 'ID' },
                    { dataIndex: 'keyword'       , title: '名稱' },
                    { dataIndex: 'sort'          , title: '排序' },
                    { dataIndex: 'total'         , title: '查詢次數' },
                    { title: 'Action', key: 'tools',  width:250,
                      render: (text, record) => 
                        <List
                          dataSource={[
                            <Button type="default" size="small" icon={<PlusCircleOutlined />} loading={record.isAddManual === true} onClick={() => {
                             this.submitAddHotKeyword(record)
                            }}>加入手動清單</Button>
                          ]}
                          renderItem={item => <List.Item>{item}</List.Item>}
                        />
                      ,
                    }
                ]}
              />
          </div>
          <div className="manual-block col_12">
            <div className="block search">
              <Form ref={this.manualFormRef}>
                <div className='flexBox col_12'>
                  <Form.Item
                    {...genFormItemAtrribute('is_manual', '熱門關鍵字狀態', 'checked')}
                  >
                    <Switch checkedChildren='手動' unCheckedChildren='自動' />
                  </Form.Item>
                </div>
                <Form.Item style={{ textAlign: 'right' }}>                  
                  <Button 
                    type="primary" 
                    style={{ marginLeft: 8 }} 
                    onClick={() => this.submitManualData()} 
                  >儲存</Button>
                </Form.Item>
              </Form>
            </div>
            
            <div className='toolbar'>
              <h3>熱門關鍵字列表(手動)<span></span></h3>
            </div>

            <Form ref={this.manualTableFormRef}>
              <Form.List name='manual_rows'>
                {(fields, { add, remove, move }) => {
                  setTimeout(() => {
                    this.setState({formListAddMethod: add})
                  }, 1000);

                  return (
                    <Fragment>
                      {fields.length > 0 && (
                        <Table
                          pagination={false}
                          rowKey={(item, idx) => idx}
                          dataSource={fields}
                          columns={[
                            {
                              dataIndex: 'id',
                              title: '#',
                              render: (id, item, idx) => idx + 1,
                            },
                            {
                              dataIndex: 'keyword',
                              title: '名稱',
                              render: (page, item, idx) => {
                                return (
                                  <Form.Item
                                    {...genFormItemAtrribute([idx, 'keyword'])}
                                    rules={[
                                      {
                                        required: true,
                                        message: '必填',
                                      },
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>
                                );
                              },
                            },
                            {
                              dataIndex: 'sort',
                              title: '排序',
                              render: (indexName, item, idx) => {
                                return (
                                  <Form.Item
                                    {...genFormItemAtrribute([
                                      idx,
                                      'sort',
                                    ])}
                                    rules={[
                                      {
                                        required: true,
                                        message: '必填',
                                      },
                                    ]}
                                  >
                                    <Input />
                                  </Form.Item>
                                );
                              },
                            },
                            {
                              dataIndex: 'action',
                              title: 'Action',
                              render: (name, item, idx) => (
                                <Form.Item>
                                  <Button danger onClick={() => remove(idx)}>
                                    刪除
                                  </Button>
                                </Form.Item>
                              ),
                            },
                          ]}
                        />
                      )}
                      <Form.Item>
                        <Button htmlType='button' onClick={() => add()}>
                          新增
                        </Button>
                      </Form.Item>
                    </Fragment>
                  );
                }}
              </Form.List>
            </Form>
          </div>
        </div>
      </Layout>
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/HotKeywords/HotKeywordsInfo.js